module.exports = __webpack_public_path__ + "5aa20a966b4c9fd362065b34bc90858f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tjx_companies_2021_chart.png
// module id = 1751
// module chunks = 0